import { baseApi } from "../baseApi";

export const salesorderApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		postSalesOrderList: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_sales_order_list`,
				method: "POST",
				body: payload,
			}),
		}),

		postSalesOrderCreate: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_sales_order`,
				method: "POST",
				body: payload,
			}),
		}),

		postSalesOrderSubmit: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.api.submit_sales_order`,
				method: "POST",
				body: payload,
			}),
		}),
		postGetVersionsForDocument: builder.mutation({
			query: ({ doctype, docname }) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_versions_for_document`,
				method: "POST",
				body: {
					doctype,
					docname,
				},
			}),
		}),

		postSalesOrderDetails: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.api.get_sales_order_details`,
				method: "POST",
				body: payload,
			}),
		}),
		postFrappeClientGet: builder.mutation({
			query: (payload) => ({
				url: `/api/method/frappe.client.get`,
				method: "POST",
				body: payload,
			}),
		}),

		postSalesOrderUpdate: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_sales_order`,
				method: "POST",
				body: payload,
			}),
		}),
		getSalesOrderIdList: builder.mutation({
      query: () => {

        const formData = new FormData();

        // Append simple fields
        formData.append('doctype',"Sales Order");
        formData.append('order_by',"modified desc");
        formData.append('view', "List");
        formData.append('start', "0");
        formData.append('page_length', "0");

        const fields = ["name"];
				const filters = [
					["Sales Order", "status", "=", "To Deliver and Bill"],
					["Sales Order", "intozi_status", "is", "not set"],
				];

				formData.append("fields", JSON.stringify(fields));
				formData.append("filters", JSON.stringify(filters));

        return {
          url: '/api/method/frappe.desk.reportview.get', // adjust endpoint
          method: 'POST',
          body: formData,
          // ⚠️ Do NOT set Content-Type header — let browser set it automatically
        };
			},
		}),
	}),
});

export const {
  usePostSalesOrderListMutation,
  usePostSalesOrderCreateMutation,
  usePostSalesOrderSubmitMutation,
  usePostGetVersionsForDocumentMutation,
  usePostSalesOrderDetailsMutation,
  usePostFrappeClientGetMutation,
  usePostSalesOrderUpdateMutation,
  useGetSalesOrderIdListMutation
} = salesorderApi;

